<span *ngIf="inputs.length === 0 && isActiveInput()" class="blinking">|</span>
<span *ngFor="let char of inputs; let i = index" (click)="onCharClick(i)">{{char}}<span
    *ngIf="showIndicator(i)" class="blinking">|</span></span>
